import React from "react"
import { Helmet } from "react-helmet"
// import Founders from "../components/About/Founders"
// import Hero from "../components/About/Hero"
import Quote from "../components/Team/Quote"
import Statement from "../components/Team/Statement"
import Team from "../components/Team/Team"
import Layout from "../components/Layout"

const TeamPage = () => {
  return (
    <>
      <Helmet>
        <title>Team | Niro</title>
      </Helmet>
      <Layout>
        {/* <Hero /> */}
        <Statement />
        {/* <Founders /> */}
        <Team />
        <Quote />
      </Layout>
    </>
  )
}

export default TeamPage
